import { render, staticRenderFns } from "./singleChoiceQuestion.vue?vue&type=template&id=69551546&scoped=true&"
import script from "./singleChoiceQuestion.vue?vue&type=script&lang=js&"
export * from "./singleChoiceQuestion.vue?vue&type=script&lang=js&"
import style0 from "./singleChoiceQuestion.vue?vue&type=style&index=0&id=69551546&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69551546",
  null
  
)

export default component.exports